module.exports = __webpack_public_path__ + "img/lock-shield-generic.67ef2fa.png";